import * as React from "react";
import { Alert } from "antd";
import "./Feedback.less";

type FeedbackBannerProps = {
  feedbackType: string;
  message: string;
  description: string;
  action: any;
  closable: boolean;
  children?: React.ReactNode;
};

export default function FeedbackBanner({
  message: propsMessage,
  feedbackType: propsFeedbackType,
  description: propsDescription,
  action: propsAction,
  closable: propsClosable = true,
}: React.PropsWithChildren<FeedbackBannerProps>) {
  const getFeedbackType = {
    Information: "info",
    Success: "succes",
    Warning: "warning",
    Error: "error",
  };

  return (
    <Alert
      className="feedback-banner"
      key={propsMessage}
      message={propsMessage}
      description={
        <span className="ant-alert-description">{propsDescription}</span>
      }
      type={getFeedbackType[propsFeedbackType]}
      showIcon
      style={{ marginBottom: 24 }}
      action={propsAction}
      closable={propsClosable}
    />
  );
}
